// PortfolioDetails.js
import React from 'react';
import { Row, Col, Input, Space } from 'antd';
import Button from '@mui/material/Button';
import {SaveRounded, WarningAmberRounded} from "@mui/icons-material";

const PortfolioDetails = ({ title, onTitleChange, onSave, isNew }) => {
  // Determine the status based on whether the title is empty
  const inputStatus = title === '' ? 'danger' : undefined;

  return (
    <Row justify={'space-between'} className={'pr-6'}>
        <Input
          status={inputStatus} // Apply the dynamic status here
          placeholder="Portfolio Title"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          style={{maxWidth: '400px', width: '60%'}}
        />
        <Space>

            <Button startIcon={<SaveRounded/>} variant={'contained'}  className={'action'} onClick={()=>onSave({saveAsNew: true})}>
                Save as New
            </Button>
            {isNew===false && (
                <Button variant={'outlined'}
                        color={'error'}
                        onClick={()=>onSave({saveAsNew: false})}
                        startIcon={<WarningAmberRounded/>}
                >
                    Update Existing
                </Button>
            )}
        </Space>

    </Row>
  );
};
export default PortfolioDetails;